import { render, staticRenderFns } from "./MainNavBarComponent.vue?vue&type=template&id=5dbc524f&scoped=true&"
import script from "./MainNavBarComponent.vue?vue&type=script&lang=js&"
export * from "./MainNavBarComponent.vue?vue&type=script&lang=js&"
import style0 from "./MainNavBarComponent.vue?vue&type=style&index=0&id=5dbc524f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbc524f",
  null
  
)

export default component.exports